export var FileType;

(function (FileType) {
  FileType["Image"] = "1";
  FileType["Audio"] = "2";
  FileType["Video"] = "3";
})(FileType || (FileType = {}));